/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private prefix = 'cristil-clean';

  constructor() {}

  /**
   * Get item from localStorage
   */
  get(key: string): any {
    try {
      const item = localStorage.getItem(`${this.prefix}-${key}`);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error getting item from localStorage:', error);
      return null;
    }
  }

  /**
   * Set item in localStorage
   */
  set(key: string, value: any): void {
    try {
      localStorage.setItem(`${this.prefix}-${key}`, JSON.stringify(value));
    } catch (error) {
      console.error('Error setting item in localStorage:', error);
    }
  }

  /**
   * Remove item from localStorage
   */
  remove(key: string): void {
    try {
      localStorage.removeItem(`${this.prefix}-${key}`);
    } catch (error) {
      console.error('Error removing item from localStorage:', error);
    }
  }

  /**
   * Clear all items with prefix
   */
  clear(): void {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(`${this.prefix}-`)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  /**
   * Clear all items with prefix (alias for clear method)
   */
  clearAll(): void {
    this.clear();
  }
}
